export class RenewalPet {
    constructor (
        public ResidentPetsKey: number = null,
        public ResidentKey: number = null,
        public RentalPetTypesKey: number = 0,
        public Breed: string = '',
        public Color: string = '',
        public Weight: number = null,
        public PetName: string = '',
        public IsServiceAnimal: boolean = false
        
    ) { }
}
